// eslint-disable-next-line import/prefer-default-export
export const MULTISPORT_PHRASES = [
  "multi",
  "multis",
  "multisp",
  "multispo",
  "multispor",
  "multisport",
  "multi sport",
  "multi-sport",
  "multi–sport",
  "multisprot",
  "multisprort",
  "multispot",
  "multyspor",
  "multispotr",
  "mltisport",
  "mulitsport",
  "msport",
  "m-sport",
  "multy sport",
  "multi szport",
  "multysport",
  "multispport",
  "multisprt",
  "multispork",
  "multisoport",
  "mulitsprot",
  "karta multisport",
  "pakiet multisport",
];
